import { SxProps } from "@mui/material";

export const sxOptionTitle: SxProps = {
	fontFamily: 'UnimedSans-Bold',
	color: '#383838',
	fontSize: '16px',
	lineHeight: '24px',
}